var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionsetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/40px/Actions"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.486279 13.034C0.179963 14.3089 0 15.6324 0 17C0 26.374 7.6258 34 16.9998 34C26.3739 34 33.9998 26.374 33.9998 17C33.9998 7.62596 26.3739 0 16.9998 0C15.6322 0 14.3088 0.179963 13.0339 0.486279L15.0633 2.51568C15.6987 2.43092 16.342 2.37209 17 2.37209C25.0661 2.37209 31.6279 8.93409 31.6279 17.0002C31.6279 25.0662 25.0661 31.6281 17 31.6281C8.93393 31.6281 2.37209 25.0662 2.37209 17.0002C2.37209 16.342 2.43108 15.6987 2.51568 15.0634L0.486279 13.034ZM8.707 17.0928C8.75824 21.6265 12.4543 25.3023 17 25.3023C21.5773 25.3023 25.302 21.5777 25.302 17.0003C25.302 12.4546 21.6262 8.7584 17.0925 8.70732L15.3735 6.98834L15.4822 6.4464C15.9794 6.37508 16.4834 6.32574 16.9998 6.32574C22.8853 6.32574 27.6743 11.1147 27.6743 17.0002C27.6743 22.8856 22.8853 27.6746 16.9998 27.6746C11.1144 27.6746 6.32542 22.8856 6.32542 17.0002C6.32542 16.4837 6.37492 15.9795 6.44608 15.4825L6.98803 15.3739L8.707 17.0928ZM10.7593 9.08227L11.5036 5.35982C11.5555 5.10063 11.4742 4.83274 11.2873 4.64582L8.20342 1.56178C7.75684 1.11535 6.99271 1.34655 6.86888 1.96583L6.15504 5.5352C6.09242 5.84815 5.84778 6.0928 5.53482 6.15542L1.96561 6.86926C1.34633 6.99308 1.11498 7.75722 1.56156 8.20364L4.6456 11.2877C4.83252 11.4744 5.10057 11.5557 5.35976 11.5039L9.08205 10.7593L16.1613 17.8386C16.393 18.0703 16.6957 18.186 16.9999 18.186C17.3042 18.186 17.6069 18.0703 17.8385 17.8386C18.3019 17.3754 18.3019 16.6249 17.8385 16.1615L10.7593 9.08227Z",
    fill: "#3C5BD2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionsetting);
export default __webpack_public_path__ + "static/media/ic_actionsetting.c97d8247ea8c8acd046af15b956047bb.svg";
export { ForwardRef as ReactComponent };